import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import Sidebar from "./newComponents/Sidebar";
import MainBody from "./newComponents/MainBody";
import { getUserList, getUserMessageList } from "../../redux/actions/chat";
import { socket } from "../../service/socket";
import { GET_MESSAGE_LIST, GET_USER_LIST } from "../../redux/constants";

const Chat = () => {
  const dispatch = useDispatch();
  const activeGroupRef = useRef(null);
  const { dataList, messagesList } = useSelector(state => state.chat);
  const { email, company } = useSelector((state) => state.auth);
  const [activeGroup, setActiveGroup] = useState({});
  const [msgList, setMsgList] = useState([]);

  // Infinite Scrolling with pagination
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  // const [hasMore, setHasMore] = useState(true);
  const hasMoreRef = useRef(true);
  const pageLimit = 20;

  const { state } = useLocation();

  useEffect(() => {
    dispatch(getUserList((res) => {}))
    return () => {
      dispatch({
        type: GET_USER_LIST,
        payload: [],
      });
      dispatch({ type: GET_MESSAGE_LIST, payload: {message: [], totalPages: 0, currentPage: 1} });
    }
  }, []);

  useEffect(() => {
    setMsgList(messagesList);
  }, [messagesList]);

  useEffect(() => {
    if(state && state.email){
      const activeThread = dataList.find(item => item.id === state.id && item.email === state.email);
      if(activeThread){
        setActiveGroup(activeThread);
      } 
      window.history.replaceState({}, document.title);
    }
  }, [dataList]);


  useEffect(() => {
    if (Object.keys(activeGroup).length !== 0) {
      setLoading(true);
      const payload = {
        sender_email: email,
        receiver_email: activeGroup.email,
      };
      dispatch(getUserMessageList(payload, page, pageLimit, (res) => {
        setLoading(false);
        hasMoreRef.current = true;
        if(res.data.totalPages === page){
          hasMoreRef.current = false;
        }
      }));
    }
    activeGroupRef.current = activeGroup;

  }, [activeGroup, page]);

  // // Group Message Received Lisinter
  useEffect(() => {
    socket.on("receiveMessage", async (data) => {
      setMsgList((prev) => {
        const oldMessages = prev.filter(
          (item) => item.chat_id !== data.success.chat_id
        );
        return [data.success, ...oldMessages];
      });

      const payload = {
        sender_email: email,
        receiver_email: activeGroupRef.current?.email,
        company_id: company.id,
      };
      socket.emit("mark_read_message", payload);

      let newMessage = dataList.find(
        (item) => item.id === data.success.sender
      );

      if (newMessage) {
        newMessage["message"] = data.success.message;
        newMessage["createdAt"] = data.success.createdAt;       
        newMessage["is_read"] = activeGroupRef.current?.id === data.success.sender ? "" : data.success.is_read;

        const oldMessage = dataList.filter(
          (item) => item.id !== data.success.sender
        );

        dispatch({
          type: GET_USER_LIST,
          payload: [newMessage, ...oldMessage],
        });
      }
    });
  }, []);

  return (
    <div
      className="w-full h-full px-6"
      style={{ maxHeight: "calc(100vh - 91px)" }}
    >
      <div className="flex flex-row w-full h-full">
        <Sidebar activeGroup={activeGroup} setActiveGroup={setActiveGroup} setPage={setPage} hasMoreRef={hasMoreRef} />
        {Object.keys(activeGroup).length !== 0 && (
          <MainBody activeGroup={activeGroup} msgList={msgList} page={page} setPage={setPage} loading={loading} hasMoreRef={hasMoreRef} />
        )}
      </div>
    </div>
  );
};

Chat.auth = { path: "/chat", role: "super-admin admin user" };
export default Chat;
